<div [formGroup]="group">
  @if (name) {
    <b>{{name}}</b>
  }
  <div class="scope-list">
    @for (value of values; track value) {
      @if (getControl(value)) {
        <label class="form-field--horizontal">
          <span>{{ display(value) }}</span>
          <span class="app-checkbox">
            <input type="checkbox" [formControl]="getControl(value)"><span class="inner"></span>
          </span>
        </label>
      }
    }
  </div>
</div>
